import React from 'react'
import PropTypes from 'prop-types'

import { FlyingCube } from 'Components/Blocks/_Legacy'
import { Border, Icon, Text, Wrapper } from 'Components/UI'
import { Button } from 'Components/UI/_Legacy'

import { heroGlyph } from 'Assets/_Legacy/BlockchainPage'
import arrowRightShortGlyph from 'Assets/_Legacy/Svg/arrow-right-short.svg'

import { useAppContext } from 'Services/AppContext'

import {
  Container,
  Content,
  CropContainer,
  ImageHolder,
  TextHolder,
  TitleHolder,
} from './styles'

function Hero({ data }) {
  const { openSupportWidget } = useAppContext()

  return (
    <>
      <Border primary topRight />
      <Container>
        <Wrapper>
          <Content>
            <TextHolder mb={[40, 40, 0]} mr={[0, 0, 0, 0, 64]}>
              <TitleHolder as="h1" mb={[16, 16, 32, 16, 20]} mt={0}>
                <Text
                  bold
                  fontSize={[32, 32, 56]}
                  lineHeight={[1.5, 1.5, 1.1, 1.5]}
                  white
                >
                  {data?.heroTitleBold}&nbsp;
                </Text>

                <Text
                  fontSize={[32, 32, 56]}
                  light
                  lineHeight={[1.5, 1.5, 1.1, 1.5]}
                  white
                >
                  {data?.heroTitleRegular}
                </Text>
              </TitleHolder>

              <Text
                fontSize={[14, 14, 16, 16, 20]}
                mb={[32, 32, 32, 32, 40]}
                white
              >
                {data?.heroDescription}
              </Text>

              <Button blueprintWhite width={250} onClick={openSupportWidget}>
                Discuss a project
                <Icon glyph={arrowRightShortGlyph} ml={12} size={10} />
              </Button>
            </TextHolder>

            <ImageHolder>
              <Icon
                glyph={heroGlyph}
                height={['110%', '110%', 550, 550, 760]}
                width={['100%', '100%', 700, 720, 900]}
              />
            </ImageHolder>
          </Content>
        </Wrapper>

        <CropContainer>
          <FlyingCube
            desktopOnly
            left={0}
            rotateAngle={39}
            size={[0, 0, 90, 90, 180]}
            top={0}
          />
        </CropContainer>
      </Container>
      <Border bottomLeft primary />
    </>
  )
}

Hero.defaultProps = {
  data: {},
}

Hero.propTypes = {
  data: PropTypes.object,
}

export default Hero
